export const textFormatter = (text) => {
    if (!text) return;
    
    const boldText = text?.replace(/\*(.*?)\*/g, '<b>$1</b>');
    const breakedAndBordText = boldText?.replace(/\\n/g, '<br />');

    return breakedAndBordText;
}